var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"actions-header__item header-favorite",attrs:{"href":this.$root.baseUrl + '/favorites'}},[_c('span',[_vm._v(_vm._s(_vm.favoritesIds.complexes.length + _vm.favoritesIds.properties.length || ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }